@if(selectedSof){
<div class="row">
<div class="col-md-6">
  <div>
    <div class="card shadow-sm ">
      <div class="card-header with-border">
        SOF
      </div>
      <div class="card-body">
        <div>
          <form #sofForm="ngForm"
          class="form-horizontal">
          <fieldset style="border: 0;" #verified
            [disabled]="!hasRole('vessels-voyages-editor')">
            <div class="form-group row">
              <app-material-organisation-selector
                class="pg-component"
                [(ngModel)]="port"
                [organisationLanguage]="'en'"
                name="port2"
                [organisations]="ports"
                [placeholder]="'port'"
                [disabled]="edit"
                [required]="true">
              </app-material-organisation-selector>
            </div>
            <div class="form-group row">
              <app-material-chunk-file-uploader
                [accept]="'.pdf'"
                name="document"
                [(ngModel)]="doc"
                (ngModelChange)="uploadDocument($event)">
              </app-material-chunk-file-uploader>
            </div>
              @if (!edit) {
                <div class="form-group row">
                    <app-material-auto-complete
                      id="loadingDischarging"
                      name="selectedDocumentType"
                      [placeholder]="'Type'"
                      [disabled]="edit"
                      [(ngModel)]="selectedSofType"
                      [items]="selectedSOFTypes"
                      [formatter]="sofTypeFormatter"
                      [required]="true">
                    </app-material-auto-complete>
                </div>
              }
            @if (edit) {
              <div class="form-group row">
                <app-material-pg-input
                  label="Type"
                  id="loadingDischargingLabel"
                  type="text"
                  [disabled]="true"
                  [ngModel]="selectedSof.sofType">
                </app-material-pg-input>
              </div>
            }
            <div class="form-group row">
              @for (l of sofEntries; track $index; let i = $index) {
                <div class="d-flex align-items-center mt-3">
                  <input
                    class="col-1"
                    type="checkbox"
                    [disabled]="l.required"
                    [checked]="l.selected"
                    (change)="l.selected = !l.selected">
                    <div class="col-10">
                      <app-material-date-time-zone
                        name="sofEntry{{i}}"
                        [label]="l.sofItem"
                        [(ngModel)]="sofEntries[i].timestampWithZone"
                        [disabled]="!(l.selected)"
                        (focused)="dateTimeZoneFocused(i)"
                        [appMaterialDateTimeZoneRequired]="l.selected">
                      </app-material-date-time-zone>
                    </div>
                    @if (l.required) {
                      <input
                        class="col-1"
                        type="checkbox"
                        [checked]="l.selected"
                        (change)="skipRequiredSofEntry(l)">}
                  </div>
                }
                @for (item of extraSofEntries; track $index; let i = $index) {
                  <div class="d-flex align-items-center mt-4">
                    <div class="col-md-1"></div>
                    <div class="col-10">
                      <app-material-date-time-zone
                        name="sofItem{{i}}"
                        [label]="item.sofItem"
                        [(ngModel)]="item.timestampWithZone">
                      </app-material-date-time-zone>
                    </div>
                    <button class="btn btn-link" (click)="removeSofItem(i)">
                      <i class="fa-solid fa-circle-minus fa-xl ms-4"></i>
                    </button>
                  </div>
                }
                @if (showAddItem) {
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-1"></div>
                      <div class="col-md-10">
                        <app-material-auto-complete
                          [formatter]="lookupItemListFormatter"
                          [(ngModel)]="extraSofEntry"
                          [items]="selectableSofItems"
                          placeholder="New item"
                          name="truck">
                        </app-material-auto-complete>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </fieldset>
            <div class="btn-group pull-right mt-3">
              @if ( edit && hasRole('vessels-voyages-editor')) {
                <app-material-pg-button
                  id="delete"
                  class="me-1"
                  (clicked)="deleteSOF()"
                  label="Delete">
                </app-material-pg-button>
              }
              <ng-container *appHideIfNotInRole="['vessels-voyages-editor']">
                <app-material-pg-button
                id="cancel"
                class="me-1"
                (clicked)="backToVoyage()"
                label="Back to voyage">
                </app-material-pg-button>
                <app-material-pg-button
                  id="sofItem"
                  class="me-1"
                  (clicked)="showAddSofItem()"
                  label="Add item">
                </app-material-pg-button>
              </ng-container>
              @if ( hasRole('vessels-voyages-editor')) {
                <div>
                  <app-material-pg-button
                    id="submit"
                    (clicked)="saveSOF()"
                    [disabled]="!sofForm.form.valid"
                    label="Save">
                  </app-material-pg-button>
                </div>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="col-md-6">
  <div>
    <app-material-pdf-viewer [fileId]="selectedSof.fileId"> </app-material-pdf-viewer>
  </div>
</div>

</div>
}